import { styled } from 'styled-components';

export const ScShowAllTournamentsCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  row-gap: 40px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.grayDarkColor};
  box-shadow:
    0 0 8px 0 rgba(0, 0, 0, 0.6),
    0 0 12px 0 rgba(0, 0, 0, 0.8);
  padding: 12px 12px 40px;
  overflow: hidden;

  & .bg {
    position: absolute;
    top: -18px;
    left: 50%;
    transform: translateX(-50%);
  }

  & .main-img {
    position: relative;
    transition: scale 0.2s ease-in-out;
    transform-origin: bottom center;
    z-index: 1;
  }

  & > a {
    align-self: stretch;
  }

  &:hover .main-img {
    scale: 1.05;
  }
`;
